import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import * as Yup from "yup";
import { useFormik } from "formik";
import { TextField } from "@mui/material";
import CustomAction from "../../../../controls/CustomAction";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { updateBookingField } from "../../../../../dispatchers/bookingDispatchers";
import useBookingApp from "../../../../../hooks/useBookingApp";

export default function AboutYou({ mainColor, handleNextStep }) {
  const { bookingSectionState } = useBookingApp();
  const { bookingModel, companyDetails } = bookingSectionState;
  const pharmacyName = companyDetails?.pharmacies[0].pharmacyName;

  const [presistedFormData, setPersistedFormData] = useState([]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: presistedFormData?.firstName || bookingModel.FirstName || "",
      lastName: presistedFormData?.lastName || bookingModel.LastName || "",
      emailAddress: presistedFormData?.emailAddress || bookingModel.Email || "",
      phoneNumber:
        presistedFormData?.phoneNumber || bookingModel.PhoneNumber || "",
    },
    validationSchema: Yup.object().shape({
      firstName: Yup.string().required("*First Name is required"),
      lastName: Yup.string().required("*Last Name is required"),
      emailAddress: Yup.string()
        .email("*Invalid email address")
        .required("*Email Address is required"),
    }),
    onSubmit: (values) => {
      localStorage.setItem("about-you-data", JSON.stringify(values));
      handleNextStep(values);
      updateBookingField({ field: "FirstName", value: values.firstName });
      updateBookingField({ field: "LastName", value: values.lastName });
      updateBookingField({ field: "Email", value: values.emailAddress });
      updateBookingField({ field: "PhoneNumber", value: values.phoneNumber });
    },
  });

  const [makePharmacyAccount, setMakePharmacyAccount] = useState(false);
  const [nominatePharmacy, setNominatePharmacy] = useState(false);
  const [termsConditions, setTermsConditions] = useState(false);

  useEffect(() => {
    const persistedData =
      JSON.parse(localStorage.getItem("about-you-data")) || null;
    setPersistedFormData(persistedData);
  }, []);

  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
      exit={{ y: 50, opacity: 0 }}
      className="bf-content-wrapper"
    >
      <div className="bf-content-header">
        <h2 className="bf-title" style={{ color: mainColor }}>
          Tell us about you
        </h2>
        <p className="bf-subtitle">
          Tell us a little about yourself so we can get your appointment set up
          quickly and smoothly
        </p>
      </div>

      <div className="bf-content-body">
        <form onSubmit={formik.handleSubmit}>
          <TextField
            className="bf-form-field"
            id="firstName"
            name="firstName"
            label="First Name"
            variant="filled"
            fullWidth
            value={formik.values.firstName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
          />

          <TextField
            className="bf-form-field"
            id="lastName"
            name="lastName"
            label="Last Name"
            variant="filled"
            fullWidth
            value={formik.values.lastName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
          />

          <TextField
            className="bf-form-field"
            id="emailAddress"
            name="emailAddress"
            label="Email Address"
            variant="filled"
            fullWidth
            value={formik.values.emailAddress}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.emailAddress && Boolean(formik.errors.emailAddress)
            }
            helperText={
              formik.touched.emailAddress && formik.errors.emailAddress
            }
          />

          <div className="optional-content">
            <p className="optional-text">
              *We'll send your confirmation and reminders to this email address
            </p>

            <div className="spacer-text">
              <div className="spacer"></div>
              <p>Optional</p>
              <div className="spacer"></div>
            </div>
          </div>

          <TextField
            className="bf-form-field"
            id="phoneNumber"
            name="phoneNumber"
            label="Phone Number"
            variant="filled"
            fullWidth
            value={formik.values.phoneNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />

          <CustomAction
            text="Continue"
            // action={() => {
            //   handleNextStep();
            // }}
            mainColor={mainColor}
            type="submit"
            disabled={!formik.values.emailAddress}
          />
        </form>

        <div className="bf-radio-group">
          <div className="bf-radio-group-item">
            <p>Make me a {pharmacyName} account</p>

            {makePharmacyAccount ? (
              <IoIosCheckmarkCircle
                className="checkmark"
                color={mainColor}
                size={22}
                onClick={() => setMakePharmacyAccount(false)}
              />
            ) : (
              <div
                className="empty-circle"
                onClick={() => setMakePharmacyAccount(true)}
              ></div>
            )}
          </div>
          <div className="bf-radio-group-item">
            <p>Nominate {pharmacyName} as my pharmacy</p>

            {nominatePharmacy ? (
              <IoIosCheckmarkCircle
                className="checkmark"
                color={mainColor}
                size={22}
                onClick={() => setNominatePharmacy(false)}
              />
            ) : (
              <div
                className="empty-circle"
                onClick={() => setNominatePharmacy(true)}
              ></div>
            )}
          </div>
          <div className="bf-radio-group-item">
            <p>
              Agree to <span>Terms and Conditions</span>
            </p>

            {termsConditions ? (
              <IoIosCheckmarkCircle
                className="checkmark"
                color={mainColor}
                size={22}
                onClick={() => setTermsConditions(false)}
              />
            ) : (
              <div
                className="empty-circle"
                onClick={() => setTermsConditions(true)}
              ></div>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
